import styled from 'styled-components/macro';
import { Callout as FitleComponentsCallout } from 'shared_components';

const Callout = styled(FitleComponentsCallout)`
  padding: 10px;
  line-height: 1.3rem;
`;

export default Callout;
